import { Command } from 'commands/Commands';

export abstract class ChangePartner extends Command {
  priority: number = 100;
  constructor(public payload: string | object, id: string) {
    super(payload, id);
  }
}
